import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/circle.png'


const _hoisted_1 = { class: "base-wrapper" }
const _hoisted_2 = { class: "common-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "content-common-width login-content"
}
const _hoisted_4 = { class: "login-main" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "tabs" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "forget-pwd-box" }
const _hoisted_11 = { class: "button-wrap" }
const _hoisted_12 = { class: "forget-pwd-box" }
const _hoisted_13 = { class: "button-wrap" }
const _hoisted_14 = {
  key: 1,
  class: "application-exp"
}
const _hoisted_15 = {
  key: 2,
  class: "application-exp"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 3,
  class: "company"
}
const _hoisted_18 = { class: "join" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-qiye-copy" })
], -1)
const _hoisted_21 = { key: 4 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_23 = { class: "edit-pwd" }
const _hoisted_24 = { class: "button-wrap" }
const _hoisted_25 = { class: "content-common-width login-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tryout = _resolveComponent("Tryout")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ForgetPwd = _resolveComponent("ForgetPwd")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-container", _ctx.desktop ? 'desktop' : ''])
  }, [
    _createVNode(_component_Tryout, {
      visible: _ctx.tryouotVisible,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tryouotVisible = false))
    }, null, 8, ["visible"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        (!_ctx.forgetFlag)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.isCommunity ? 'left-bg-community' : 'left-bg')
              }, null, 2),
              _createElementVNode("div", _hoisted_4, [
                (!_ctx.logined)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h1", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('欢迎登录')), 1),
                        _hoisted_6
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["tab-item", index == _ctx.curIndex ? 'cur' : '']),
                            key: index,
                            onClick: ($event: any) => (_ctx._changeIndex(index))
                          }, _toDisplayString(_ctx.$t(item)), 11, _hoisted_8))
                        }), 128))
                      ]),
                      _withDirectives(_createVNode(_component_a_form, {
                        name: "custom-validation",
                        class: "login-form",
                        rules: _ctx.rules,
                        model: _ctx.loginForm,
                        ref: "formRef"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            class: "form-item",
                            "has-feedback": "",
                            name: "phone"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "phone",
                                placeholder: _ctx.$t('请输入手机号'),
                                value: _ctx.loginForm.phone,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.phone) = $event))
                              }, null, 8, ["placeholder", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            class: "form-item",
                            name: "password"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_password, {
                                id: "password",
                                maxlength: 20,
                                type: "password",
                                placeholder: _ctx.$t('请输入密码'),
                                value: _ctx.loginForm.password,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.password) = $event))
                              }, null, 8, ["placeholder", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            class: "form-item code",
                            name: "code"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "code",
                                placeholder: _ctx.$t('请输入验证码'),
                                value: _ctx.loginForm.code,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginForm.code) = $event)),
                                autocomplete: "off"
                              }, null, 8, ["placeholder", "value"]),
                              _createElementVNode("img", {
                                ref: "code",
                                src: _ctx.codeImg,
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx._setCodeurl && _ctx._setCodeurl(...args))),
                                alt: ""
                              }, null, 8, _hoisted_9)
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.forgetFlag = true))
                            }, _toDisplayString(_ctx.$t('忘记密码')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              htmlType: "submit",
                              disabled: _ctx.disabledLogin,
                              onClick: _ctx._login
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('登录')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["rules", "model"]), [
                        [_vShow, _ctx.curIndex === 0]
                      ]),
                      _withDirectives(_createVNode(_component_a_form, {
                        name: "custom-validation",
                        class: "login-form",
                        rules: _ctx.rules,
                        model: _ctx.loginFormPhone,
                        ref: "formPhoneRef"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            "has-feedback": "",
                            name: "phone",
                            ref: "phone",
                            class: "form-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "phone",
                                placeholder: _ctx.$t('请输入手机号'),
                                value: _ctx.loginFormPhone.phone,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loginFormPhone.phone) = $event))
                              }, null, 8, ["placeholder", "value"])
                            ]),
                            _: 1
                          }, 512),
                          _createVNode(_component_a_form_item, {
                            name: "code",
                            class: "form-item code"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "code",
                                placeholder: _ctx.$t('请输入短信验证码'),
                                value: _ctx.loginFormPhone.code,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.loginFormPhone.code) = $event))
                              }, null, 8, ["placeholder", "value"]),
                              _createVNode(_component_a_button, {
                                onClick: _ctx._getCode,
                                disabled: _ctx.disabled
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.btnTxt)), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick", "disabled"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.forgetFlag = true))
                            }, _toDisplayString(_ctx.$t('忘记密码')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              htmlType: "submit",
                              disabled: _ctx.disabledLogin,
                              onClick: _ctx._login
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('登录')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["rules", "model"]), [
                        [_vShow, _ctx.curIndex === 1]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isCommunity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.$t('还没有账号？试用社区版')) + " ", 1),
                      _createVNode(_component_RouterLink, {
                        to: { path: '/register', query: { returnUrl: _ctx.returnUrl, isCommunity: '1', bdVid: _ctx.route.query.bdVid } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('立即注册')), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.$t('还没有账号？立即')) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.trialUrl,
                        target: "_self"
                      }, _toDisplayString(_ctx.$t('申请使用')), 9, _hoisted_16)
                    ])),
                (_ctx.logined && _ctx.isHaveMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("h1", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('选择你的组织')), 1),
                        _createElementVNode("span", {
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx._chooseCompany && _ctx._chooseCompany(...args))),
                          class: "iconfont icon-jinru-copy"
                        })
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('您已加入以下组织')), 1),
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companys, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["company-list", _ctx.curCompanyIndex === index ? 'active' : '']),
                            onClick: ($event: any) => (_ctx.curCompanyIndex = index),
                            onDblclick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx._chooseCompany && _ctx._chooseCompany(...args))),
                            key: item.id
                          }, [
                            _hoisted_20,
                            _createElementVNode("span", null, _toDisplayString(item.name), 1)
                          ], 42, _hoisted_19))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.logined && _ctx.isFirst && !_ctx.isHaveMore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("h1", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('欢迎登录')) + " ", 1),
                        _hoisted_22
                      ]),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('首次登录,请先设置密码')), 1),
                      _createVNode(_component_a_form, {
                        name: "custom-validation",
                        class: "login-form",
                        rules: _ctx.rules,
                        model: _ctx.loginForm,
                        ref: "formEditRef"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            class: "form-item",
                            name: "newPassword"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "newPassword",
                                type: "password",
                                maxlength: 20,
                                placeholder: _ctx.$t('设置密码'),
                                value: _ctx.loginForm.newPassword,
                                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.loginForm.newPassword) = $event))
                              }, null, 8, ["placeholder", "value"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            class: "form-item",
                            name: "surePassword"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                id: "surePassword",
                                type: "password",
                                maxlength: 20,
                                placeholder: _ctx.$t('确认密码'),
                                value: _ctx.loginForm.surePassword,
                                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.loginForm.surePassword) = $event))
                              }, null, 8, ["placeholder", "value"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              disabled: _ctx.disabledLogin,
                              onClick: _ctx._enterPlatform
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('进入平台')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["rules", "model"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_ForgetPwd, {
              key: 1,
              onBack: _cache[13] || (_cache[13] = ($event: any) => (_ctx.forgetFlag = false))
            }))
      ])
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("section", _hoisted_25, [
        _createElementVNode("div", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('版权声明')), 1),
          _createTextVNode("|"),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('联系我们')), 1),
          _createTextVNode("|"),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Copyright © 2022 design order 沪ICP备2020035517号')), 1)
        ])
      ])
    ])
  ], 2))
}